import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeaturesRoutingModule } from './features-routing.module';
import { PrecastWorksheetComponent } from './worksheet-new/precast-worksheet/precast-worksheet.component';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AsReceivedWorksheetComponent } from './worksheet-new/native-soil-worksheet/as-received-worksheet/as-received-worksheet.component';
import { MoistureConditioningWorksheetComponent } from './worksheet-new/native-soil-worksheet/moisture-conditioning-worksheet/moisture-conditioning-worksheet.component';
import { CompactionWorksheetComponent } from './worksheet-new/native-soil-worksheet/compaction-worksheet/compaction-worksheet.component';
import { NativeSoilWorksheetComponent } from './worksheet-new/native-soil-worksheet/native-soil-worksheet/native-soil-worksheet.component';
import { SingleProctorWorksheetComponent } from './worksheet-new/native-soil-worksheet/single-proctor-worksheet/single-proctor-worksheet.component';
import { AsReceivedHistoryComponent } from './worksheet-new/native-soil-worksheet/as-received-history/as-received-history.component';
import { MoistureConditioningHistoryComponent } from './worksheet-new/native-soil-worksheet/moisture-conditioning-history/moisture-conditioning-history.component';
import { NativeSoilHistoryComponent } from './worksheet-new/native-soil-worksheet/native-soil-history/native-soil-history.component';
import { CompactionHistoryComponent } from './worksheet-new/native-soil-worksheet/compaction-history/compaction-history.component';
import { MatRadioModule } from '@angular/material/radio';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    PrecastWorksheetComponent,
    AsReceivedWorksheetComponent,
    MoistureConditioningWorksheetComponent,
    CompactionWorksheetComponent,
    NativeSoilWorksheetComponent,
    SingleProctorWorksheetComponent,
    AsReceivedHistoryComponent,
    MoistureConditioningHistoryComponent,
    NativeSoilHistoryComponent,
    CompactionHistoryComponent,
  ],
  imports: [
  CommonModule, 
  RouterModule, 
  FeaturesRoutingModule, 
  MatTableModule,
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  FormsModule,
  MatCardModule,
  SharedModule,
  MatMenuModule,
  MatCheckboxModule,
  MatChipsModule,
  MatRadioModule,
  MatButtonToggleModule,
  CdkDrag,
  CdkDropList],
})
export class FeaturesModule {}
